import React, { useState } from 'react';
import { X, AlertTriangle, User, Mail, Calendar, Trash2 } from 'lucide-react';
import { deleteEmployeeAccount } from '../../services/employeeService';

/**
 * Modal de confirmation pour supprimer un intervenant
 */
const DeleteEmployeeModal = ({ employee, onClose, onSuccess }) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState('');

  const handleDelete = async () => {
    setIsDeleting(true);
    setError('');

    try {
      console.log('🗑️  Suppression de l\'intervenant:', employee.id);
      
      // Appeler le service de suppression
      const result = await deleteEmployeeAccount(employee.id);
      
      console.log('✅ Suppression réussie:', result);
      
      if (onSuccess) {
        onSuccess(employee, result);
      }

    } catch (error) {
      console.error('❌ Erreur lors de la suppression:', error);
      setError(error.message || 'Une erreur est survenue lors de la suppression');
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div className="resource-modal-container">
      <div className="resource-modal-content resource-fade-in" style={{ maxWidth: '500px' }}>
        {/* En-tête du modal */}
        <div className="resource-modal-header">
          <div className="flex items-center">
            <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center mr-3">
              <AlertTriangle className="w-5 h-5 text-red-600" />
            </div>
            <div>
              <h3 className="resource-modal-title">Supprimer l'intervenant</h3>
              <p className="resource-modal-subtitle">Cette action est irréversible</p>
            </div>
          </div>
          <button 
            onClick={onClose}
            className="resource-modal-close"
            disabled={isDeleting}
          >
            <X size={20} />
          </button>
        </div>

        {/* Corps du modal */}
        <div className="resource-modal-body">
          {error && (
            <div className="resource-error-message mb-4">
              {error}
            </div>
          )}

          <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
            <div className="flex items-start">
              <AlertTriangle className="w-5 h-5 text-red-600 mt-0.5 mr-3 flex-shrink-0" />
              <div>
                <h4 className="font-medium text-red-800 mb-1">Attention</h4>
                <p className="text-red-700 text-sm">
                  Vous êtes sur le point de supprimer définitivement cet intervenant. 
                  Cette action supprimera :
                </p>
                <ul className="text-red-700 text-sm mt-2 space-y-1">
                  <li>• Le compte Firebase Authentication</li>
                  <li>• L'enregistrement dans Firestore</li>
                  <li>• Tous les rendez-vous associés</li>
                </ul>
                <p className="text-red-700 text-sm mt-2 font-medium">
                  Cette action ne peut pas être annulée.
                </p>
              </div>
            </div>
          </div>

          {/* Informations de l'intervenant */}
          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <h4 className="font-medium text-gray-900 mb-3">Intervenant à supprimer</h4>
            <div className="space-y-3">
              <div className="flex items-center">
                <User className="w-4 h-4 text-gray-500 mr-2" />
                <span className="text-gray-700">
                  {employee.firstName} {employee.lastName}
                </span>
              </div>
              <div className="flex items-center">
                <Mail className="w-4 h-4 text-gray-500 mr-2" />
                <span className="text-gray-700">{employee.email}</span>
              </div>
              {employee.role && (
                <div className="flex items-center">
                  <Calendar className="w-4 h-4 text-gray-500 mr-2" />
                  <span className="text-gray-700 capitalize">{employee.role}</span>
                </div>
              )}
            </div>
          </div>

          {/* Actions */}
          <div className="resource-actions">
            <button
              type="button"
              onClick={onClose}
              className="resource-btn resource-btn-secondary"
              disabled={isDeleting}
            >
              Annuler
            </button>
            <button
              type="button"
              onClick={handleDelete}
              className="resource-btn resource-btn-danger flex items-center"
              disabled={isDeleting}
            >
              <Trash2 size={16} className="mr-2" />
              {isDeleting ? 'Suppression...' : 'Supprimer définitivement'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteEmployeeModal;
